var map = {
	"./en/example.yml": 155,
	"./en/hos.yml": 156,
	"./en/main.yml": 30,
	"./en/markdown.yml": 157,
	"./en/news.yml": 158,
	"./en/sfs.yml": 159,
	"./fr/example.yml": 160,
	"./fr/hos.yml": 161,
	"./fr/main.yml": 31,
	"./fr/markdown.yml": 162,
	"./fr/news.yml": 163,
	"./fr/sfs.yml": 164,
	"./hr/hos.yml": 165,
	"./hr/main.yml": 32,
	"./hr/sfs.yml": 166,
	"./it/hos.yml": 167,
	"./it/main.yml": 33,
	"./it/sfs.yml": 168
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 154;